import { isFeatureEnabled } from '@/utils/general/uiHelper'

import { ELITE_BENEFITS } from './constants'

/** Compact unlock-soon card vs progress bar for ACTIVATING_SOON + bookingCount 2. */
export function shouldShowEliteUnlockSoonCard({
    isUserLoggedIn,
    displayStatus,
    completedTrips,
    currentTrips = 0,
    upcomingTrips = 0,
}: {
    isUserLoggedIn: boolean
    displayStatus?: string
    completedTrips: number
    currentTrips?: number
    upcomingTrips?: number
}): boolean {
    if (!isUserLoggedIn) return false

    if ((displayStatus ?? '').toUpperCase() === 'ACTIVATING_SOON' && completedTrips === 2) {
        return currentTrips + upcomingTrips > 2
    }

    return completedTrips > 2
}

/** Reads benefit tiles from offerJson (`eliteUnlockSoonContent`); falls back to local defaults. */
export function getEliteUnlockSoonBenefits(): string[] {
    try {
        const config = isFeatureEnabled()?.eliteUnlockSoonContent
        if (Array.isArray(config?.benefits) && config.benefits.length > 0) {
            return config.benefits.filter((item: unknown): item is string => typeof item === 'string')
        }
    } catch {
        // Malformed offerJson — use local defaults.
    }
    return [...ELITE_BENEFITS]
}
